export default __webpack_public_path__ + "static/media/lock profit.0a4c05e4.png";